import type { MenuItem } from '../menu/types';

export const resolveGridMetadataId = (
  isChildGrid: boolean,
  menuItem: MenuItem | null
): number | null => {
  if (isChildGrid || !menuItem) return null;
  return menuItem.contentType === 'zMenuItem' ? menuItem.linkId : menuItem.id;
};

type ResolveGridPageTitleParams = {
  isStandaloneGridByKey: boolean;
  standaloneTitle?: string;
  menuCaption?: string;
  metadataTitle?: string | null;
};

export const resolveGridPageTitle = ({
  isStandaloneGridByKey,
  standaloneTitle,
  menuCaption,
  metadataTitle,
}: ResolveGridPageTitleParams): string => {
  if (isStandaloneGridByKey) {
    return standaloneTitle || menuCaption || '';
  }

  return metadataTitle ?? '';
};
